import { compose } from 'ramda';
import { connect } from 'react-redux';

import { getQuickLinksTabs } from './utils/selectors';
import { IAppState } from '../../../common/state';
import { selectSuburbanBlackFridayBannerUrl } from '../../../selectors/selectSuburbanBlackFridayBannerUrl';
import { EDealType } from '../../../types/dealType';
import { dealTypeFromJsonQuery, isSuburban, offerTypeFromJsonQuery } from '../../../utils/category';
import { withEmptyRendering } from '../../../utils/hoc/withEmptyRendering';
import { IQuickLinksProps, IQuickLinksStateProps, QuickLinks } from '../../components/QuickLinks';

export function mapStateToProps(state: IAppState): IQuickLinksStateProps {
  const { jsonQuery } = state.results;
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const countrysideBlackFridayLink = selectSuburbanBlackFridayBannerUrl(state);
  const isCommercial = jsonQuery._type === 'commercialrent' || jsonQuery._type === 'commercialsale';

  return {
    countrysideBlackFridayLink: dealType === EDealType.Sale ? countrysideBlackFridayLink : undefined,
    tabs: getQuickLinksTabs(state),
    isSuburbanListing: isSuburban(offerType),
    avgPriceInformer: isCommercial ? state.results.avgPriceInformer || null : null,
    isRent: dealType === EDealType.Rent,
    oldQuickLinks: state.results.oldQuickLinks,
  };
}

export function shouldHideQuickLinks(props: IQuickLinksProps) {
  const hasQuickLinks = props.tabs.length > 0;
  const hasOldQuickLinks = Boolean(props.oldQuickLinks && props.oldQuickLinks.links.length > 0);

  return !hasQuickLinks && !hasOldQuickLinks && !props.avgPriceInformer;
}

export const QuickLinksContainer = compose(
  connect(mapStateToProps),
  withEmptyRendering(shouldHideQuickLinks),
)(QuickLinks);
